import React, { Component } from "react";
import { MenuItem, SubMenuItem } from "./SideBar_MenuItem";
import ReactDOM from "react-dom";
import $ from "jquery";

import { GetLastTermCourses, GetStudentName } from "../../GeneralAPI";
import { withLocalize, Translate } from "react-localize-redux";
import { NavLink } from "react-router-dom";
class SideBar extends Component {
  FetchData = () => {
    GetLastTermCourses().then(data => {
      this.setState({ data: data, loading: false });
    });
  };
  constructor(props) {
    super(props);
    this.state = { data: [], name: "" };
    this.servicesInReact = [
      {
        name_en: "Student Results",
        name_ar: "نتائج الطالب",
        icon: "fas fa-graduation-cap",
        logo: "results.jpg",
        link: "/results"
      },
      {
        name_en: "Student Schedule",
        name_ar: "جدول الطالب",
        icon: "fas fa-list-ol",
        logo: "schedule.jpg",
        link: "/Schedule/General"
      },
      // {
      //   name_en: "Student Transcript",
      //   name_ar: "السجل الدراسى",
      //   icon: "fas fa-chart-line",
      //   logo: "transcript.jpg",
      //   link: "/transcript"
      // },
      {
        name_en: "Clinic Reservation",
        name_ar: "حجز العيادة",
        icon: "fas fa-stethoscope",
        logo: "clinc.jpg",
        link: "/clinic"
      }
    ];
    this.FetchData();
  }

  //this.props.isLogin
  componentDidUpdate(prevProps) {
    if (prevProps.isLogin === this.props.isLogin) {
    } else {
      this.FetchData();
    }
  }

  render() {
    let langCode = "en";
    // console.log("courses",this.state.data);
    if (this.props.activeLanguage !== undefined) {
      langCode = this.props.activeLanguage.code;
    }
    console.log(this.servicesInReact);
    return (
      <div id="sidebar" class="sidebar">
        <div data-scrollbar="true" data-height="100%">
          <ul class="nav">
            <li class="nav-profile">
              <a href="javascript:;">
                <div class="cover with-shadow" />
                <div class="image">
                  {this.props.isLogin && (
                    <img src={`api/General/Image/${this.props.ID}`} alt="" />
                  )}
                  {!this.props.isLogin && (
                    <img src="../assets/img/user/user-13.png" alt="" />
                  )}
                </div>
                <div class="info">
                  {langCode == "ar"
                    ? this.props.name.nameArabic
                    : this.props.name.nameEnglish}
                  <small>{this.props.ID}</small>
                </div>
              </a>
            </li>
          </ul>

          <ul class="nav">
            <li class="nav-header"></li>
            <MenuItem
              text={langCode == "en" ? "Home" : "الرئيسية"}
              icon="fas fa-home"
              link="/Home"
            />

            {this.state.data.length > 0 ? (
              <React.Fragment>
                <hr />
                <li class="nav-header">
                  <Translate id="general.courses" />
                </li>
                {this.state.data.map((item, key) => (
                  <MenuItem
                    key={item.id}
                    text={
                      langCode === "ar"
                        ? item.crsNameArabic
                        : item.crsNameEnglish
                    }
                    icon={`far fa-circle text-${item.colorClass}`}
                    link={`/course/${item.crsNumMod}`}
                  />
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            <hr />
            <li class="nav-header">
              <Translate id="general.services" />{" "}
            </li>

            {this.servicesInReact.map(item => (
              <MenuItem
                text={langCode == "en" ? item.name_en : item.name_ar}
                icon={item.icon}
                link={item.link}
              />
            ))}

            {this.props.services.map(item =>
              item.code != "8" ? (
                <li>
                  {/* <NavLink to={`/StudentApp.aspx/${item.code}`}> */}

                  <a href={`StudentApp.aspx/${item.code}`}>
                    {/* <a
                  href="#"
                  onClick={event => {
                    document.getElementById(item.code).submit();
                    event.preventDefault();
                  }}
                > */}

                    <i class={item.icon}></i>
                    <span>
                      {langCode == "ar" ? item.name_ar : item.name_en}
                    </span>
                  </a>
                  {/* </NavLink> */}
                </li>
              ) : (
                <li>
                  {/* <NavLink to={`/StudentApp.aspx/${item.code}`}> */}

                  <a
                    href="#"
                    onClick={event => {
                      document.getElementById(item.code).submit();
                      event.preventDefault();
                    }}
                  >
                    {" "}
                    {/* <a
                  href="#"
                  onClick={event => {
                    document.getElementById(item.code).submit();
                    event.preventDefault();
                  }}
                > */}
                    <i class={item.icon}></i>
                    <span>
                      {langCode == "ar" ? item.name_ar : item.name_en}
                    </span>
                  </a>
                  {/* </NavLink> */}
                </li>
              )
            )}

            {/* <MenuItem text="Student Results" icon="fa fa-gem" countBadge="10">
              <SubMenuItem link="Counter" text="Test1" />
              <SubMenuItem link="index.html" text="Sub Level">
                <SubMenuItem link="index.html" text="Sub Level">
                  <SubMenuItem link="index.html" text="Sub Level">
                    <SubMenuItem link="index.html" text="Sub Level">
                      <SubMenuItem link="index.html" text="Test1" />
                    </SubMenuItem>
                  </SubMenuItem>
                </SubMenuItem>
              </SubMenuItem>
            </MenuItem> */}

            {/* <MenuItem
              text="Exam Schedule"
              icon="fas fa-magnet"
              link="/exam-schedule"
            /> */}

            {/* <MenuItem
              text="Questionnaire"
              icon="fas fa-sort-numeric-down"
              link="/Counter"
            /> */}
          </ul>
        </div>
      </div>
    );
  }
}
export default withLocalize(SideBar);



// WEBPACK FOOTER //
// ./src/components/sidebar/SideBar.js